
import { useState } from "react";
import { useOriginalResumes } from "@/hooks/useOriginalResumes";

/**
 * Hook for managing resume selection operations
 */
export const useResumeSelection = (onResumeContentUpdate: (content: string, filename: string) => void) => {
  const [selectedResumeId, setSelectedResumeId] = useState<string | null>(null);
  const { data: originalResumes = [], isLoading: isLoadingOriginalResumes, refetch: refetchOriginalResumes } = useOriginalResumes();

  // Handle selecting an existing resume
  const handleResumeSelect = (resumeId: string) => {
    if (resumeId === "new-upload") {
      setSelectedResumeId(null);
      onResumeContentUpdate('', '');
      return;
    }
    
    const selectedResume = originalResumes.find(resume => resume.id === resumeId);
    if (selectedResume) {
      setSelectedResumeId(resumeId);
      onResumeContentUpdate(
        selectedResume.content || '', 
        selectedResume.original_filename || ''
      );
    }
  };

  return {
    selectedResumeId,
    setSelectedResumeId,
    originalResumes,
    isLoadingOriginalResumes,
    refetchOriginalResumes,
    handleResumeSelect
  };
};
